import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

const amounts = [5, 10, 25, 50, 100];

export default function MonthlyDonor() {
  const { t } = useI18n();
  const tiers = (t("monthly.tiers") || []).map((x, i) => ({ ...x, amount: amounts[i], featured: i === 4 }));
  return (
    <div data-testid="monthly-donor-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.monthly.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.monthly.t1")}<br/><span className="italic text-warm-orange">{t("pages.monthly.t2")}</span></h1>
          <p className="text-deep-blue/70 mt-6 max-w-2xl">{t("pages.monthly.sub")}</p>
        </div>
      </section>
      <section className="py-16 bg-ivory">
        <div className="max-w-6xl mx-auto px-5 lg:px-10 grid md:grid-cols-3 lg:grid-cols-5 gap-4">
          {tiers.map((tier, i) => (
            <div key={tier.name} className={`rounded-2xl p-6 flex flex-col ${tier.featured?"bg-deep-blue text-ivory":"bg-white border border-black/5"}`} data-testid={`tier-${tier.name}`}>
              <div className={`text-xs uppercase tracking-[0.2em] ${tier.featured?"text-gold":"text-warm-orange"}`}>{t("monthly.levelLabel")} 0{i+1}</div>
              <h3 className="font-display text-2xl mt-2">{tier.name}</h3>
              <div className={`font-display text-5xl mt-4 ${tier.featured?"text-gold":"text-deep-blue"}`}>{tier.amount}€<span className="text-base">{t("monthly.perMonth")}</span></div>
              <p className={`text-sm mt-3 ${tier.featured?"text-ivory/70":"text-deep-blue/60"}`}>{tier.desc}</p>
              <Link to="/faire-un-don" className={`mt-6 py-3 rounded-full text-sm font-semibold text-center ${tier.featured?"btn-gold":"btn-ghost-blue"}`} data-testid={`tier-cta-${tier.name}`}>{t("common.chooseTier")}</Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
